module.exports = __webpack_public_path__ + "static/media/r23.29c22573.jpg";